import Vue from 'vue'
import stickyHeader from './components/sticky-header'

require('./components/cookieconsent')

new Vue({
  name: 'MainApp',
  el: '#wrapper',
  data: {
    theme: "dark",
    menu: {
      open: false
    }
  },
  components: { stickyHeader },
})
